module.exports = __webpack_public_path__ + "img/11.2bd51d11.png";